import SortByAlphaIcon from '@mui/icons-material/SortByAlpha';
import { TextField, Tooltip, Typography } from '@mui/material';
import { action, computed, makeObservable, runInAction, when } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import ReactComponent from '../ReactComponent';

class OrdemSecretario extends ReactComponent {
    timeoutSalvar;
    refCampo;

    constructor(props) {
        super(props);

        makeObservable(this, {
            colocarFocoCampo: action,
            registro: computed,
            componenteExibicao: computed,
            identificadorCampo: computed,
            handleChangeOrdem: action,
            salvarOrdenacaoSecretario: action,
            ordenacaoSecretario: computed,
            handleOnFocus: action,
            handleOnBlur: action
        });

        this.refCampo = React.createRef();
    }

    componentDidMount() {
        this.colocarFocoCampo();
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        this.colocarFocoCampo();
    }

    colocarFocoCampo() {
        if (
            this.sessaoStore.campoFocoPosOrdenacao === this.identificadorCampo &&
            this.sessaoStore.numeroProcessoFocoPosOrdenacao === this.registro.numeroProcesso
        ) {
            setTimeout(() => {
                if (!this.registro.rendered) {
                    runInAction(() => (this.store.processoScroll = this.registro));
                }

                when(
                    () => {
                        return this.refCampo.current;
                    },
                    () => {
                        return this.refCampo.current.focus();
                    }
                );
            }, 1);
        }
    }

    get registro() {
        return this.observableProps.registro;
    }

    get componenteExibicao() {
        return this.observableProps.componenteExibicao ? this.observableProps.componenteExibicao : '';
    }

    get identificadorCampo() {
        return `OrdemSecretario-${this.componenteExibicao}`;
    }

    handleChangeOrdem = (event) => {
        let ordem = event.target.value;
        this.registro.informacaoProcessoSalaSessao.ordenacaoSecretario = ordem;
        if (this.timeoutSalvar) {
            clearTimeout(this.timeoutSalvar);
        }
        this.timeoutSalvar = setTimeout(this.salvarOrdenacaoSecretario.bind(this, ordem), 2000);
    };

    salvarOrdenacaoSecretario = (ordem) => {
        this.salaSessaoStore
            .salvarOrdenacaoSecretario(this.registro, ordem)
            .then(() => this.salaSessaoStore.ordenarProcessos());
    };

    get ordenacaoSecretario() {
        let ordem = this.registro.informacaoProcessoSalaSessao.ordenacaoSecretario;
        return ordem ? ordem : '';
    }

    handleOnFocus = () => {
        this.sessaoStore.numeroProcessoFocoPosOrdenacao = this.registro.numeroProcesso;
        this.sessaoStore.campoFocoPosOrdenacao = this.identificadorCampo;
    };

    handleOnBlur = () => {
        if (this.sessaoStore.numeroProcessoFocoPosOrdenacao === this.registro.numeroProcesso) {
            this.sessaoStore.numeroProcessoFocoPosOrdenacao = undefined;
            this.store.campoFocoPosOrdenacao = undefined;
        }
    };

    render() {
        return (
            <span>
                <Tooltip
                    title={
                        <>
                            <Typography
                                display="inline"
                                fontSize="14px"
                                fontWeight="bold"
                                color="inherit"
                            >
                                Ordenação do Secretário
                            </Typography>
                            <SortByAlphaIcon style={{ marginLeft: '4px', verticalAlign: 'middle', fill: 'orange' }} />
                        </>
                    }
                >
                    <TextField
                        value={this.ordenacaoSecretario}
                        disabled={this.registro.necessitaImportacaoSalaSessao}
                        margin="none"
                        variant="outlined"
                        id={'idOrdenacaoSecretario' + this.registro.numeroProcesso + this.nextKey}
                        onChange={this.handleChangeOrdem}
                        onFocus={this.handleOnFocus}
                        onBlur={this.handleOnBlur}
                        inputRef={this.refCampo}
                        slotProps={{
                            htmlInput: {
                                maxLength: 6,
                                style: { width: '6ch', height: '28px', fontSize: '14px', padding: '0px 7px' }
                            }
                        }}
                    />
                </Tooltip>
            </span>
        );
    }
}

export default inject('stores')(observer(OrdemSecretario));
